import type { Phrase } from '../types';
import type { coreEn } from './core.en';

export const coreMl: Partial<Record<keyof typeof coreEn, Phrase>> = {
  snHome: 'ഹോം',
  snExplore: 'വേദികൾ കാണുക',
  snEventTypes: 'പരിപാടികൾ',
  snLocations: 'സ്ഥലങ്ങൾ',
  snInspiration: 'ആശയങ്ങൾ',
  snAbout: 'ഞങ്ങളെക്കുറിച്ച്',
  snListVenue: 'വേദി ചേർക്കുക',
  snLogin: 'ലോഗിൻ',
  snBook: 'വേദി ബുക്ക് ചെയ്യുക',
  snSkip: 'ഉള്ളടക്കത്തിലേക്ക് പോകുക',

  mmMenu: 'മെനു',
  mmClose: 'അടയ്ക്കുക',
  mmHomeSub: 'തിരയലും തിരഞ്ഞെടുത്ത വേദികളും',
  mmExploreSub: { one: '{count} വേദി', other: '{count} വേദികൾ' },
  mmExploreSubNone: 'എല്ലാ വേദികളും',
  mmEventsSub: { one: '{count} പരിപാടി', other: '{count} പരിപാടികൾ' },
  mmLocationsSub: '{cities} എന്നിവയും മറ്റും',
  mmLocationsSubNone: 'നഗരം അനുസരിച്ച് വേദികൾ',
  mmInspirationSub: 'ഗൈഡുകളും ആശയങ്ങളും',
  mmAboutSub: 'ആഘോഷ എങ്ങനെ പ്രവർത്തിക്കുന്നു',
  mmSpotlight: 'ശ്രദ്ധേയമായ വേദി',
  mmOccasions: 'പരിപാടി അനുസരിച്ച് കാണുക',
  mmReady: 'നിങ്ങൾ തയ്യാറാകുമ്പോൾ',
  mmTalk: 'ഞങ്ങളോട് സംസാരിക്കൂ',
  mmMyBookings: 'എന്റെ ബുക്കിംഗുകൾ',

  ftTagline: 'വിവാഹം, കോൺഫറൻസ്, ആഘോഷങ്ങൾ എന്നിവയ്ക്കുള്ള ഓഡിറ്റോറിയങ്ങളും വേദികളും കണ്ടെത്തി, താരതമ്യം ചെയ്ത്, ബുക്കിംഗ് അഭ്യർത്ഥന അയയ്ക്കാം.',
  ftExplore: 'വേദികൾ',
  ftAllVenues: 'എല്ലാ വേദികളും',
  ftLocations: 'പ്രധാന സ്ഥലങ്ങൾ',
  ftResources: 'പരിപാടി ആസൂത്രണം',
  ftCompany: 'കമ്പനി',
  ftAbout: 'Aghosha-യെക്കുറിച്ച്',
  ftContact: 'ബന്ധപ്പെടുക',
  ftPrivacy: 'സ്വകാര്യതാ നയം',
  ftHowItWorks: 'ബുക്കിംഗ് എങ്ങനെ',
  ftGuides: 'ആസൂത്രണ ഗൈഡുകൾ',
  ftFaq: 'ചോദ്യങ്ങളും ഉത്തരങ്ങളും',
  ftPlanTitle: 'വലിയ ഒരു പരിപാടി ആസൂത്രണം ചെയ്യുന്നുണ്ടോ?',
  ftPlanBody: 'തീയതി, അതിഥികളുടെ എണ്ണം, പരിപാടിയുടെ തരം എന്നിവ പറയൂ. ശരിയായ വേദി കണ്ടെത്താൻ ഞങ്ങൾ സഹായിക്കാം.',
  ftPlanCta: 'ഞങ്ങളോട് സംസാരിക്കൂ',
  ftMadeIn: 'കേരളത്തിൽ നിർമ്മിച്ചത്, എല്ലാ ആഘോഷങ്ങൾക്കും.',
  ftBrandLineA: 'സ്ഥലം കണ്ടെത്തൂ.',
  ftBrandLineB: 'നിമിഷം ഒരുക്കൂ.',
  ftAddress: 'വിലാസം',
  ftContactLabel: 'ബന്ധപ്പെടാൻ',

  vcFrom: 'മുതൽ',
  vcView: 'വേദി കാണുക',
  vcGuests: '{count} അതിഥികൾ',
  vcRooms: { one: '{count} മുറി', other: '{count} മുറികൾ' },
  vcSave: '{name} സേവ് ചെയ്യുക',
  vcUnsave: '{name} സേവ് ചെയ്തതിൽ നിന്ന് മാറ്റുക',
  priceUnitHour: '/ മണിക്കൂർ',
  priceUnitHalfDay: '/ സെഷൻ',
  priceUnitDay: '/ ദിവസം',

  evWedding: 'വിവാഹം',
  evEngagement: 'വിവാഹനിശ്ചയം',
  evReception: 'റിസപ്ഷൻ',
  evBirthday: 'ജന്മദിനം',
  evConference: 'കോൺഫറൻസ്',
  evSeminar: 'സെമിനാർ',
  evWorkshop: 'വർക്ക്‌ഷോപ്പ്',
  evCultural: 'സാംസ്കാരിക പരിപാടി',
  evMusic: 'സംഗീത പരിപാടി',
  evCorporate: 'കോർപ്പറേറ്റ് മീറ്റിംഗ്',
  evLaunch: 'ഉൽപ്പന്ന ലോഞ്ച്',
  evReligious: 'മതപരമായ ചടങ്ങ്',
  evOther: 'മറ്റു പരിപാടി',

  occWeddings: 'വിവാഹങ്ങൾ',
  occWeddingsBody: 'ചടങ്ങിനും റിസപ്ഷനും വരുന്ന എല്ലാവർക്കും ഇടമുള്ള മനോഹരമായ ഹാളുകൾ.',
  occConferences: 'കോൺഫറൻസുകൾ',
  occConferencesBody: 'കൃത്യസമയത്ത് നടക്കേണ്ട മീറ്റിംഗുകൾക്ക് സ്റ്റേജും സ്ക്രീനും ഇരിപ്പിടവും.',
  occSeminars: 'സെമിനാറുകളും വർക്ക്‌ഷോപ്പുകളും',
  occSeminarsBody: 'പ്രഭാഷണങ്ങൾക്കും പരിശീലനങ്ങൾക്കും സൗകര്യപ്രദമായ ഹാളുകൾ.',
  occCultural: 'സാംസ്കാരിക പരിപാടികൾ',
  occCulturalBody: 'കലാപരിപാടികൾക്കും സമൂഹ കൂട്ടായ്മകൾക്കുമായുള്ള ഓഡിറ്റോറിയങ്ങൾ.',
  occCelebrations: 'ആഘോഷങ്ങൾ',
  occCelebrationsBody: 'ജന്മദിനം, വാർഷികം, കുടുംബ സംഗമങ്ങൾ — ആഘോഷിക്കാൻ ഇടമുള്ള വേദികൾ.',
  occCorporate: 'കോർപ്പറേറ്റ് പരിപാടികൾ',
  occCorporateBody: 'ലോഞ്ചുകൾ, ടൗൺഹാളുകൾ, കമ്പനി ദിനങ്ങൾ — പ്രൊഫഷണലായി.',
};
